import { useState, useId } from 'react';
import { cn } from '../lib/utils';
import { useBranding } from '../lib/branding';

interface BrandLogoProps {
  // box sizes the logo, e.g. "h-7 w-7".
  box: string;
  className?: string;
}

// Rows of the scanline X, in the 64x64 box shared with public/favicon.svg.
const SCANLINES: [number, number][] = [
  [11.9, 13], [39.1, 13],
  [18.7, 21.22], [32.3, 21.22],
  [25.5, 29.43],
  [18.7, 37.65], [32.3, 37.65],
  [11.9, 45.86], [39.1, 45.86],
];

function XcodecMark({ className }: { className?: string }) {
  // Two marks on one page (sidebar + login) must not share a gradient id.
  const grad = useId();
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" className={className}>
      <defs>
        <linearGradient id={grad} gradientUnits="userSpaceOnUse" x1="0" y1="13" x2="0" y2="51">
          <stop offset="0" stopColor="#5BE6F7" />
          <stop offset="1" stopColor="#2B6FFF" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" fill="#0B1220" />
      <g fill={`url(#${grad})`}>
        {SCANLINES.map(([x, y]) => (
          <rect key={`${x}-${y}`} x={x} y={y} width="13" height="5.14" rx="2.57" />
        ))}
      </g>
    </svg>
  );
}

// BrandLogo shows the uploaded logo, or the stock mark when there is none
// (or the image can't be loaded).
export function BrandLogo({ box, className }: BrandLogoProps) {
  const { logoUrl } = useBranding();
  // A new logo URL gets a fresh try; only the one that failed is skipped.
  const [failedUrl, setFailedUrl] = useState('');

  if (logoUrl && failedUrl !== logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        onError={() => setFailedUrl(logoUrl)}
        className={cn(box, 'object-contain', className)}
      />
    );
  }
  return <XcodecMark className={cn(box, 'overflow-hidden', className)} />;
}
